import {
    TimePickerInput,
    TimePickerInputBaseProps,
} from "@impero-com/common/components/form/fields/timePickerInput/timePickerInput";
import { BaseRHFWidgetProps } from "@impero-com/common/components/form/rhfFields/types";
import { FieldValues, useController } from "react-hook-form";
import { ZodDate } from "zod";

interface RHFTimePickerInputProps<TFieldsValues extends FieldValues>
    extends BaseRHFWidgetProps<TFieldsValues, Date>, TimePickerInputBaseProps {
    schema: ZodDate;
}

export function RHFTimePickerInput<TFieldsValues extends FieldValues>({
    label,
    name,
    control,
    schema,
    disabled,
    styleVariant,
    getPopupContainer,
    nodeAfter,
    format,
}: RHFTimePickerInputProps<TFieldsValues>) {
    const { field, fieldState } = useController({ name, control, disabled });

    const allowClear = schema.isNullable();

    return (
        <TimePickerInput
            onChange={field.onChange}
            onBlur={field.onBlur}
            fieldRef={field.ref}
            value={field.value}
            error={fieldState.error?.message}
            styleVariant={styleVariant}
            nodeAfter={nodeAfter}
            format={format}
            disabled={field.disabled}
            allowClear={allowClear}
            label={label}
            getPopupContainer={getPopupContainer}
        />
    );
}
